import { Step } from "../data/steps";

interface Props {
  step: Step;
}

export const StepCard = ({ step }: Props) => {
  return (
    <article className="flex w-full flex-col gap-6 rounded-[24px] border border-white/20 px-6 py-10 xl:flex-1">
      <div className="flex h-10 items-center gap-3">
        <span className="inline-flex h-[34px] w-[52px] items-center justify-center rounded-full bg-[#FFD100] text-[19px] font-bold text-[#0D0D0D] md:text-[23px]">
          {step.number}
        </span>
        <img src={step.icon} alt="" width={40} height={40} className="block" />
      </div>

      <div className="flex flex-col gap-1 text-white">
        <h3 className="text-[19px] font-bold leading-[1.2] md:text-[23px]">{step.title}</h3>
        <p className="text-[16px] leading-[1.6]">{step.description}</p>
      </div>
    </article>
  );
};
